module.exports = __webpack_public_path__ + "img/product_1.f5a9f2d.jpg";